export default __webpack_public_path__ + "static/media/icons.0d5c8ada.svg";